export const setLocalStorageItem = (key, value) => window.localStorage.setItem(key, value);
export const getLocalStorageItem = (key) => window.localStorage.getItem(key);
export const getSessionStorageItem = (key) => window.sessionStorage.getItem(key);